import React from 'react';

import ProgressRing from '@adsk/alloy-react-progress-ring';

import { useTranslation } from '../i18n';

export const LoadingSuggestion = ({
  searchValue,
}: {
  searchValue?: string;
}) => {
  const { t } = useTranslation();

  if (!searchValue) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0 16px 4px',
        height: 56,
      }}
    >
      <ProgressRing style={{ marginLeft: 3, marginRight: 14 }} />
      <span>{t('LOADING_SEARCH', { search: searchValue })}</span>
    </div>
  );
};
